(() => {
  const selectors = [
    'cart-drawer.active',
    '#Details-menu-drawer-container[open]',
    'details-modal.header__search details[open]',
    '.mobile-facets__disclosure[open]'
  ];

  let rafId = null;

  const update = () => {
    if (!document.body) return;
    const shouldHide = selectors.some((selector) => document.querySelector(selector));
    document.body.classList.toggle('inbox-hidden', shouldHide);
  };

  const schedule = () => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      update();
    });
  };

  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'open'],
  });

  document.addEventListener('toggle', schedule, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update, { once: true });
  } else {
    update();
  }
})();
